import Phaser from 'phaser';

import confettiUrl from '@/features/letterParty/assets/images/confetti.svg?url';
import hatUrl from '@/features/letterParty/assets/images/hat.svg?url';

import type { LetterPartyTheme } from '@/features/letterParty/types';

const STATIC_SVG_TEXTURE_SCALE = 2;

export const TEXTURE_KEYS = {
	confetti: 'letter-party-confetti',
	hat: 'letter-party-hat',
	sandBottom: 'letter-party-sand-bottom',
	sandcastle: 'letter-party-sandcastle',
	sandLeft: 'letter-party-sand-left',
	sandRight: 'letter-party-sand-right',
	swimmingFloat: 'letter-party-swimming-float',
};

export function preloadStaticLetterPartyAssets(scene: Phaser.Scene, theme: LetterPartyTheme) {
	const svgConfig = { scale: STATIC_SVG_TEXTURE_SCALE };
	const { decorations } = theme.images.gameScreen;

	scene.load.svg(TEXTURE_KEYS.confetti, normalizePhaserAssetUrl(confettiUrl), svgConfig);
	scene.load.svg(TEXTURE_KEYS.hat, normalizePhaserAssetUrl(hatUrl), svgConfig);
	scene.load.svg(TEXTURE_KEYS.sandBottom, normalizePhaserAssetUrl(decorations.sandBottom), svgConfig);
	scene.load.svg(TEXTURE_KEYS.sandcastle, normalizePhaserAssetUrl(decorations.sandcastle), svgConfig);
	scene.load.svg(TEXTURE_KEYS.sandLeft, normalizePhaserAssetUrl(decorations.sandLeft), svgConfig);
	scene.load.svg(TEXTURE_KEYS.sandRight, normalizePhaserAssetUrl(decorations.sandRight), svgConfig);
	scene.load.svg(TEXTURE_KEYS.swimmingFloat, normalizePhaserAssetUrl(decorations.swimmingFloat), svgConfig);
}

function normalizePhaserAssetUrl(url: string): string {
	if (!url.startsWith('data:') || url.includes(';base64,')) {
		return url;
	}

	const [metadata, data = ''] = url.split(',');
	const mimeType = metadata.slice('data:'.length).split(';')[0] || 'image/svg+xml';
	const decodedData = decodeURIComponent(data);
	const bytes = new TextEncoder().encode(decodedData);
	const binary = Array.from(bytes, (byte) => String.fromCharCode(byte)).join('');

	return `data:${mimeType};base64,${window.btoa(binary)}`;
}
